export default __webpack_public_path__ + "static/yukkurifavicon-1.0.0.png";